/**
 * DialogBackdrop theme values.
 */
import { Components } from "@oui/system/components"
import spacing from "../../spacing"

const appearances: Components["Dialog"]["Backdrop"]["appearances"] = {
  default: {
    backgroundColor: "rgba(0,0,0,0.6)",
    padding: spacing.xl,
    ">  *": {
      margin: "0 auto",
      maxWidth: "calc(100% - 0.01px) !important"
    }
  },
  none: {}
}

export default { appearances }
